import React from "react";
import { useSelector } from "react-redux";
import EmptyTemplates from "../img/templateImg.webp";
import { Row, Col } from "react-bootstrap";

export default function NoSavedTemplates({ saveTemplate }) {
  const lang = useSelector(
    (state) => state.changeLang.language.stepThree.templates
  );

  return (
    <Row>
      <Col xs={12} md={10} className="mx-auto">
        <div className="d-flex justify-content-center">
          <img
            src={EmptyTemplates}
            alt="no templates"
            loading="lazy"
            className="img-fluid"
            height="198"
            width="261"
          />
        </div>
        <div className="text-center mt-3 text-gray">
          {lang[4]}{" "}
          <span
            onClick={saveTemplate}
            className="text-secondary cursor-pointer text-capitalize"
          >
            {lang[5]}
          </span>{" "}
          {lang[6]}
        </div>
      </Col>
    </Row>
  );
}
